import { render, staticRenderFns } from "./RegisteredIndex.vue?vue&type=template&id=4fa91e1a&scoped=true"
import script from "./RegisteredIndex.vue?vue&type=script&lang=js"
export * from "./RegisteredIndex.vue?vue&type=script&lang=js"
import style0 from "./RegisteredIndex.vue?vue&type=style&index=0&id=4fa91e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa91e1a",
  null
  
)

export default component.exports